import { createSelector } from 'reselect';

const getFunnelForProcess = (processId, funnelList) => {
  return (funnelList || [])
    .find(funnel => funnel.processId === processId)
    ?.funnelId;
};

export const selectFunnelByProcess = createSelector(
  [
    (state) => state.funnel,
    (state, processId) => processId,
  ],
  (funnelList, processId) => getFunnelForProcess(processId, funnelList),
);
